<template>
    <div id="bot-image-message" class="" @mouseenter="hovered = true" @mouseleave="hovered = false">
        <viewer :id="'imageViewer-' + data.raw.uniqMessageId" :images="[imageSrc()]">
            <div class="cb-img-preview" @click="show">
                <img
                    :id="'img-' + data.raw.uniqMessageId"
                    :src="imageSrc()"
                    class="img-thumbnail ant-upload-list-picture-card-container"
                    style="object-fit: cover"
                />
                <md-icon v-if="hovered" class="cb-pr-icon" @click="show"> visibility</md-icon>
            </div>
        </viewer>

        <span v-if="data.data.meta" class="message">{{ data.data.meta }}</span>
    </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import _ from "lodash";

Vue.use(Viewer);
export default {
    name: "BotImageMessage",
    props: ["data"],
    data() {
        return {
            previewImg: false,
            hovered: false,
        };
    },
    methods: {
        show() {
            const id = "img-" + this.data.raw.uniqMessageId;
            document.getElementById(id).click();
        },
        imageSrc() {
            const imageUrl =
                _.get(this.data, "raw.payload.imageUrl", _.get(this.data, "raw.payload")) ||
                _.get(this.data, "raw.payload");
            return imageUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
.cb-pr-icon {
    position: absolute;
}

.cb-img-preview {
    max-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .cb-pr-icon {
        z-index: 2;
    }
}

#bot-image-message {
    position: relative;

    .cb-img-preview:hover {
        cursor: pointer;
        filter: grayscale(100%);
    }

    .message {
        margin: 18px 6px;
        border-radius: 6px;
    }
}
</style>
